'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@repo/design-system/components/ds/button';
import { Icon } from '@repo/design-system/components/ds/icon';
import React, { useEffect, useState } from 'react';
import { MapDetailsModal } from '../map-details-modal/map-details-modal';
export const MapDetailsButton = () => {
  const $ = _c(16);
  const [isMapDetailsOpen, setIsMapDetailsOpen] = React.useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [mounted, setMounted] = useState(false);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      setMounted(true);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  if (!mounted) {
    return null;
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => setIsHovered(true);
    t3 = () => setIsHovered(false);
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => setIsMapDetailsOpen(true);
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Icon icon="info" decorative={true} />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isHovered) {
    t6 = isHovered && <span>Details</span>;
    $[6] = isHovered;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <div onMouseEnter={t2} onMouseLeave={t3}><Button variant="ghost" onClick={t4} color="primary" size="md">{t5}{t6}</Button></div>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = t9 => {
      const {
        open
      } = t9;
      return setIsMapDetailsOpen(open);
    };
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== isMapDetailsOpen) {
    t9 = <MapDetailsModal isOpen={isMapDetailsOpen} onOpenChange={t8} />;
    $[11] = isMapDetailsOpen;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  let t10;
  if ($[13] !== t7 || $[14] !== t9) {
    t10 = <>{t7}{t9}</>;
    $[13] = t7;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};